<div class="header">
    <div class="shortinfo">

        <div class="stat-card" *ngFor="let info of shortinfo"  (click)="addFolder(addFolderDialog, info.name)">
            <div class="stat-primary">
                <span class="name">{{info.name}} <span [innerHTML]="info.icon" [style.color]="info.color"></span></span>
                <h4 [ngStyle]="{'color': info.color}"> {{info.value}}</h4>
                <p class="lilInfo">{{info.increase}}</p>
            </div>
            <div class="stat-icon">

            </div>
        </div>


    </div>
</div>
<div class="left-right-wrapper">
    <div class="left">




        <div class="adtTracking">

            <label> <i class="fa fa-thumb-tack" aria-hidden="true"></i> ADT Tracking</label>

            <mat-tab-group mat-stretch-tabs="true">
                <mat-tab label="Admissions (4)">

                    <table class="table">
                        <tr>
                            <th>&nbsp;</th>
                            <th>&nbsp;</th>
                            <th width="150">&nbsp;</th>
                        </tr>
                        <tr>
                            <td>
                                <p class="patientName">
                                    Sarah Johnson

                                    <i class="fa fa-reddit-alien border" aria-hidden="true"></i>

                                    <span class="conlist border">
                                        <i class="fa fa-file-text-o" aria-hidden="true"></i>
                                        6/16

                                    </span>

                                    <i class="fa fa-list" aria-hidden="true"></i>


                                </p>
                                <p class="smallInfo">Age 78 Pending </p>
                                <p class="smallInfo"> Post-surgical care</p>
                                <p class="textWithIcon"> <mat-icon>access_time</mat-icon> 10:30 AM</p>
                            </td>
                            <td>
                                <p class="roleLabel"> <mat-icon>person_add</mat-icon> Admissions Required Docs</p>

                                <p class="doucmentInline">
                                    <i class="fa fa-file-text-o grey" aria-hidden="true"></i>
                                    <i class="fa fa-check-circle-o green" aria-hidden="true"></i>
                                    <i class="fa fa-file-text-o grey" aria-hidden="true"></i>
                                    <i class="fa fa-check-circle-o green" aria-hidden="true"></i>
                                    <i class="fa fa-file-text-o grey" aria-hidden="true"></i>
                                    <i class="fa fa-check-circle-o green" aria-hidden="true"></i>
                                </p>
                                <p class="roleLabel green"> <mat-icon>medical_services</mat-icon> Nursing Required Docs
                                </p>
                                <p class="doucmentInline">
                                    <i class="fa fa-file-text-o grey" aria-hidden="true"></i>
                                    <i class="fa fa-check-circle-o green" aria-hidden="true"></i>
                                    <i class="fa fa-file-text-o grey" aria-hidden="true"></i>
                                    <i class="fa fa-check-circle-o green" aria-hidden="true"></i>
                                    <i class="fa fa-file-text-o grey" aria-hidden="true"></i>
                                    <i class="fa fa-check-circle-o green" aria-hidden="true"></i>
                                </p>
                            </td>
                            <td class="text-right">
                                <p class="statusTask fill">In Progress</p>
                                <p><button class="dbtn blackBtn">Assign Rooms</button></p>
                            </td>
                        </tr>

                    </table>

                </mat-tab>
                <mat-tab label="Discharge (1)"> Content 2 </mat-tab>
                <mat-tab label="Transfers (1)"> Content 3 </mat-tab>
                <mat-tab label="COC (4)"> Content 4</mat-tab>
            </mat-tab-group>

        </div>


        <div class="adtTracking">

            <label> <i class="fa fa-user-o" aria-hidden="true"></i> Last 5 Residents Managed</label>

            <div class="residentBlock">

                <div class="image">
                    DK
                </div>

                <div class="residentInfo">
                    <h4>Dorothy Martinez</h4>
                    <p>Age 84 &nbsp; Room 101</p>
                    <p>Last Activity: Medication administered 30 min ago</p>
                    <p>Managed by: Nurse Williams</p>
                </div>

                <div class="action">
                    <p class="label fill">Stable</p>
                    <button mat-icon-button><mat-icon>more_horiz</mat-icon></button>
                </div>

            </div>
            <div class="residentBlock">

                <div class="image">
                    DK
                </div>

                <div class="residentInfo">
                    <h4>Dorothy Martinez</h4>
                    <p>Age 84 &nbsp; Room 101</p>
                    <p>Last Activity: Medication administered 30 min ago</p>
                    <p>Managed by: Nurse Williams</p>
                </div>

                <div class="action">
                    <p class="label fill">Stable</p>
                    <button mat-icon-button><mat-icon>more_horiz</mat-icon></button>
                </div>

            </div>

        </div>


        <div class="adtTracking">

            <label> <i class="fa fa-shield" aria-hidden="true"></i>
                Audit & Compliance Dashboard</label>

            <mat-tab-group mat-stretch-tabs="true">
                <mat-tab label="overview">

                    <div class="auditBlocks">

                        <div class="blocks">
                            <h5 class="green">92%</h5>
                            <p>Overall Compliance</p>
                        </div>

                        <div class="blocks">
                            <h5 class="red">3</h5>
                            <p>Critical Findings</p>
                        </div>

                        <div class="blocks">
                            <h5 class="orange">8</h5>
                            <p>Corrections Pending</p>
                        </div>

                    </div>

                    <div class="auditTimline adtTracking">
                        <label> <i class="fa fa-calendar" aria-hidden="true"></i>
                            Audit Timeline</label>

                            <p class="auditTime" >Last Survey:  <span>Jan 15, 2025</span></p>
                            <p class="auditTime" >Next Expected: <span>May 15, 2025</span></p>

                    </div>

                    <div class="reports">
                        <span class="label adtTracking mb-0"> <i class="fa fa-file-text-o" aria-hidden="true"></i>
                            Genreate Compliance Reports</span>

                             <span class="label adtTracking mb-0"> <i class="fa fa-file-text-o" aria-hidden="true"></i>
                            Quality Metrics</span>

                    </div>

                </mat-tab>
                <mat-tab label="Potential"> Potential </mat-tab>
                <mat-tab label="Compliance"> Compliance </mat-tab>
                <mat-tab label="Findings"> Findings</mat-tab>
            </mat-tab-group>

        </div>

        <div class="adtTracking">

            <label> <i class="fa fa-bolt" aria-hidden="true"></i>
                Recent Activity</label>

            <div class="residentBlock">

                <div class="image">
                    <i class="fa fa-stethoscope green" aria-hidden="true"></i>

                </div>

                <div class="residentInfo">
                    <h4>New Admission Completed <span class="activity admissionType">Admission</span></h4>
                    <p>Sarah Johnson admitted to Room 301B</p>
                    <div class="personTIme">
                        <p><i class="fa fa-user-o" aria-hidden="true"></i> Nurse Williams</p>
                        <p><i class="fa fa-clock-o" aria-hidden="true"></i>30 minutes ago</p>
                    </div>
                </div>



            </div>

        </div>

    </div>
    <div class="right">



        <div class="secHeader">
            <label> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                Compliance Alerts</label>
            <div class="numsec">
                <button class="highPriority dbtn">29</button>
                <button class="dbtn">34 total</button>
            </div>
        </div>

        <div class="alert-item alert-red">
            <div class="flex items-start gap-3">
                <div class="flex-1">
                    <div class="flex items-center justify-between mb-2">
                        <h4 class="font-medium"> <i class="fa fa-line-chart red" aria-hidden="true"></i>Change of
                            Condition</h4>
                        <span class="badge badge-destructive">9</span>
                        <button class="highPriority dbtn">High Priority</button>
                    </div>
                    <p class="text-sm text-muted-foreground mb-3">Residents with significant condition changes requiring
                        documentation</p>
                    <button class="viewBtn dbtn"> View 9 Residents</button>
                </div>
            </div>
        </div>

        <div class="alert-item alert-blue">
            <div class="flex items-start gap-3">
                <div class="flex-1">
                    <div class="flex items-center justify-between mb-2">
                        <h4 class="font-medium"> <i class="fa fa-certificate blue" aria-hidden="true"></i> MDS
                            Suggestions</h4>
                        <span class="badge badge-destructive">12</span>
                        <button class="highPriority dbtn">High Priority</button>
                    </div>
                    <p class="text-sm text-muted-foreground mb-3">Residents requiring MDS assessment updates</p>
                    <button class="viewBtn dbtn"> View 9 Residents</button>
                </div>
            </div>
        </div>

        <div class="alert-item alert-red">
            <div class="flex items-start gap-3">
                <div class="flex-1">
                    <div class="flex items-center justify-between mb-2">
                        <h4 class="font-medium"> <i class="fa fa-file-text-o red" aria-hidden="true"></i> Certificate of
                            Coverage</h4>
                        <span class="badge badge-destructive">9</span>
                        <button class="highPriority dbtn">High Priority</button>
                    </div>
                    <p class="text-sm text-muted-foreground mb-3">Missing Certificate of Coverage documentation</p>
                    <button class="viewBtn dbtn"> View 8 Residents</button>
                </div>
            </div>
        </div>

        <div class="alert-item alert-orange">
            <div class="flex items-start gap-3">
                <div class="flex-1">
                    <div class="flex items-center justify-between mb-2">
                        <h4 class="font-medium"> <i class="fa fa-calendar-o orange" aria-hidden="true"></i> Timely
                            Braden Scale Missing</h4>
                        <span class="badge badge-destructive">9</span>
                        <button class="mediumPriority dbtn">Medium Priority</button>
                    </div>
                    <p class="text-sm text-muted-foreground mb-3">Overdue Braden Scale assessments</p>
                    <button class="viewBtn dbtn"> View 8 Residents</button>
                </div>
            </div>
        </div>

    </div>
</div>




<ng-template #addFolderDialog>
  <h2 matDialogTitle>{{selectedTab}}</h2>
  <mat-dialog-content>

    <div class="" *ngIf="selectedTab === 'Skilled Mix'">
        <div class="graph">
        <label>Payor Mix Breakdown</label>

         <div class="graphHolder">
            <div class="leftgraph">
                <h5>Skilled Residents (91 total)</h5>
                 <div class="graphHere">
                    <img src="assets/images/chart1.png" alt="Line Chart" />
                </div>
            </div>
            <div class="rightgraph">
                <h5>Non-Skilled Residents (36 total)</h5>
                  <div class="graphHere">
                    <img src="assets/images/chart2.png" alt="Line Chart" />
                </div>
            </div>
         </div>

    </div>

    <div class="graph">
        <label>Skilled vs Non-Skilled Trends</label>

         <div class="graphHolder">
            <div class="leftgraph">
                <h5>Resident Count Over Time</h5>
                <div class="graphHere">
                   
                <mat-tab-group mat-stretch-tabs="true">
                <mat-tab label="Last Month">

                     <img src="assets/images/chart3.png" alt="Line Chart" />

                </mat-tab>
                <mat-tab label="Past 3 Months"> Content 2 </mat-tab>
                <mat-tab label="Past 6 Months"> Content 3 </mat-tab>
                <mat-tab label="Past 12 Months"> Content 4</mat-tab>
            </mat-tab-group>




                </div>
            </div>
            <div class="rightgraph">
                <h5>Payor Mix Trends</h5>
                 <div class="graphHere">
                   
                <mat-tab-group mat-stretch-tabs="true">
                <mat-tab label="Last Month">

                     <img src="assets/images/chart4.png" alt="Line Chart" />

                </mat-tab>
                <mat-tab label="Past 3 Months"> Content 2 </mat-tab>
                <mat-tab label="Past 6 Months"> Content 3 </mat-tab>
                <mat-tab label="Past 12 Months"> Content 4</mat-tab>
            </mat-tab-group>




                </div>
            </div>
         </div>

    </div>
    </div>

     <div class="" *ngIf="selectedTab === 'Census'">
        

    <div class="graph">
       
         <div class="graphHolder">
            <div class="leftgraph w100">
                <h5>Resident Count Over Time</h5>
                <div class="graphHere">
                   
                <mat-tab-group mat-stretch-tabs="true">
                <mat-tab label="Last Month">

                     <img src="assets/images/chart5.png" alt="Line Chart" />

                </mat-tab>
                <mat-tab label="Past 3 Months"> Content 2 </mat-tab>
                <mat-tab label="Past 6 Months"> Content 3 </mat-tab>
                <mat-tab label="Past 12 Months"> Content 4</mat-tab>
            </mat-tab-group>




                </div>
            </div>
         </div>

    </div>
    </div>

  </mat-dialog-content>
  <mat-dialog-actions
    align="start"
    fxLayout="row"
    fxLayoutAlign="space-between center"
  >
    <button mat-button  color="basic" >
      Cancel
    </button>
    <button
      mat-button
      color="primary"
     
    >
      Add
    </button>
  </mat-dialog-actions>
</ng-template> 